module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_8003.ff9dba35.png";